export const name = 'screenIn' as const
